export const GRADIENTS = {
  purple: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  blue: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
  pink: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
  orange: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
  green: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
  red: "linear-gradient(135deg, #cb2d3e 0%, #ef473a 100%)",
};
